module.exports = __webpack_public_path__ + "img/jo1.51bcb60b.png";